import Get from './get';
import Save from './save';

export default {
  Get,
  Save,
};
